
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93WcYhFmgji7Meta } from "/home/runner/work/videlio/videlio/apps/frontend/src/pages/[...slug].vue?macro=true";
import { default as component_45stubYiCcOA0mW3Meta } from "/home/runner/work/videlio/videlio/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@20.14.15_db0@0.2.4_encoding@0.1.13_eslint@9.20._jj2y2i7bibd7mbh5nycfkprwui/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubYiCcOA0mW3 } from "/home/runner/work/videlio/videlio/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@20.14.15_db0@0.2.4_encoding@0.1.13_eslint@9.20._jj2y2i7bibd7mbh5nycfkprwui/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/home/runner/work/videlio/videlio/apps/frontend/src/pages/[...slug].vue")
  },
  {
    name: component_45stubYiCcOA0mW3Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubYiCcOA0mW3
  }
]